import React from 'react';
import { setVolume } from '../utils/audioUtils';
import './Controls.css';

interface ControlsProps {
  onChangeOctaveRange: (direction: 'up' | 'down') => void;
  canMoveDown: boolean;
  canMoveUp: boolean;
}

const Controls: React.FC<ControlsProps> = ({ onChangeOctaveRange, canMoveDown, canMoveUp }) => {
  const handleVolumeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    // Convert 0-100 range to -60-0 range for Tone.js
    const volumeValue = (parseInt(e.target.value) / 100) * 60 - 60;
    setVolume(volumeValue);
  };

  return (
    <div className="controls-container">
      <div className="control-group">
        <label>Volume</label>
        <input 
          type="range" 
          min="0" 
          max="100" 
          defaultValue="83" // -10dB
          onChange={handleVolumeChange}
        />
      </div>
      
      <div className="control-group">
        <label>Octave</label>
        <div className="octave-buttons">
          <button 
            onClick={() => onChangeOctaveRange('down')} 
            disabled={!canMoveDown}
          >
            -
          </button>
          <button 
            onClick={() => onChangeOctaveRange('up')} 
            disabled={!canMoveUp}
          >
            +
          </button>
        </div>
      </div>
    </div>
  );
};

export default Controls;
